import { useEffect, useRef } from 'react';
import { LineStyle } from 'lightweight-charts';

export function useOverlayLines({ seriesRef, stopLoss, takeProfit, activeLimitOrders, coin, loading }) {
  const stopLossLineRef = useRef(null);
  const takeProfitLineRef = useRef(null);
  const limitOrderLinesRef = useRef([]);

  // SL/TP lines
  useEffect(() => {
    const series = seriesRef.current;
    if (!series) return;

    [stopLossLineRef, takeProfitLineRef].forEach(ref => {
      if (ref.current) {
        series.removePriceLine(ref.current);
        ref.current = null;
      }
    });

    if (stopLoss) {
      stopLossLineRef.current = series.createPriceLine({
        price: parseFloat(stopLoss),
        color: '#f6465d',
        lineWidth: 2,
        lineStyle: LineStyle.Dashed,
        axisLabelVisible: true,
        title: `Stop Loss (SL) $${stopLoss}`,
      });
    }

    if (takeProfit) {
      takeProfitLineRef.current = series.createPriceLine({
        price: parseFloat(takeProfit),
        color: '#0ecb81',
        lineWidth: 2,
        lineStyle: LineStyle.Dashed,
        axisLabelVisible: true,
        title: `Take Profit (TP) $${takeProfit}`,
      });
    }
  }, [seriesRef, stopLoss, takeProfit, loading]);

  // Limit order lines
  useEffect(() => {
    const series = seriesRef.current;
    if (!series || loading) return;

    limitOrderLinesRef.current.forEach(line => series.removePriceLine(line));
    limitOrderLinesRef.current = [];

    (activeLimitOrders || [])
      .filter(o => o.coinId === coin?.id && o.status === 'PENDING')
      .forEach(order => {
        const isBuy = order.side === 'BUY';
        const line = series.createPriceLine({
          price: parseFloat(order.price),
          color: isBuy ? '#2575fc' : '#ff9800',
          lineWidth: 1.5,
          lineStyle: LineStyle.Dotted,
          axisLabelVisible: true,
          title: `Limit ${order.side}: $${order.price} (${order.quantity})`,
        });
        limitOrderLinesRef.current.push(line);
      });
  }, [seriesRef, activeLimitOrders, coin, loading]);
}
